import { memo } from "react";
import { classNames } from "helpers";

// Section wrapper koji slijedi VehicleInfoCard pattern: bottom border, padding,
// bold title gore lijevo. Children su tipično grid od InfoCard primitiva.
export const Section: React.FC<{ title: string; children: React.ReactNode }> = memo(
  ({ title, children }) => (
    <div className="border-b border-slate-200 pt-4 px-4 pb-4">
      {/* Isti stil naslova kao SectionCard na unosu. */}
      <div className="text-xs uppercase tracking-wide text-slate-500 font-semibold mb-3">{title}</div>
      {children}
    </div>
  )
);

// Read-only info kartica: oblak labela + vrijednost. Ako je `clickable=true`
// dodaj se hover stil + edit ikona u uglu (callback se rješava preko onClick
// na vanjskom wrapperu).
export const InfoCard: React.FC<{
  label: string;
  value: React.ReactNode;
  colSpan?: 1 | 2;
}> = memo(({ label, value, colSpan }) => (
  <div
    className={classNames(
      "border border-slate-200 bg-slate-50 p-3 rounded-sm min-h-[70px]",
      colSpan === 2 ? "col-span-2" : ""
    )}
  >
    <div className="text-sm text-slate-600">{label}</div>
    <div className="text-md font-medium text-slate-800 truncate">
      {value == null || value === "" ? "-" : value}
    </div>
  </div>
));

// Grid wrapper koji prima 2/3/4 kolone. Default 4.
export const InfoGrid: React.FC<{
  columns?: 2 | 3 | 4;
  children: React.ReactNode;
}> = memo(({ columns = 4, children }) => {
  const cls = columns === 2 ? "grid-cols-2" : columns === 3 ? "grid-cols-3" : "grid-cols-4";
  return <div className={classNames("grid gap-3 mb-3", cls)}>{children}</div>;
});

// Placeholder za sekciju koja još nema BE persistenciju — diskretno javlja
// korisniku da je struktura tu ali sadržaj će doći kasnije.
export const EmptyHint: React.FC<{ text?: string }> = memo(({ text }) => (
  <div className="border border-dashed border-slate-200 bg-slate-50/50 p-4 rounded-sm text-xs text-slate-400 mb-3">
    {text ?? "Podaci za ovu sekciju još nisu spremljeni za ovaj oglas."}
  </div>
));
